import React, { useState } from 'react'
import './CSS/ResetPassword.css'

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const sendResetLink = async () => {
        const res = await fetch('/api/forgot-password', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email })
        });
        const data = await res.json();
        setMessage(data.message || data.errors);
    };

    return (
        <div className='loginsignup'>
            <div className="loginsignup-container">
            <h1>Elfelejtett jelszó</h1>
            <div className="loginsignup-fields">
                <input type="email" placeholder="Email" value={email}
                    onChange={(e) => setEmail(e.target.value)} />
            </div>
            <button onClick={sendResetLink}>Küldés</button>
            <p style={{color:'blueviolet'}}>{message}</p>
            </div>
        </div>
    );
};

export default ForgotPassword;
